import React from "react";
import classes from "./stockStatusMessage.module.css";
import { useStockStatusMessage } from "../../Pregrine/StockStatusMessage/useStockStatusMessage";

const StockStatusMessage = (props) => {
  const { cartItems } = props;

  const talonProps = useStockStatusMessage({ cartItems });
  const { hasOutOfStockItem } = talonProps;

  const stockStatusMessageElement = hasOutOfStockItem ? (
    <div className={classes.root}>
      <span>
        An item in your cart is currently out-of-stock and must be removed in
        order to Checkout.
      </span>
    </div>
  ) : null;

  return stockStatusMessageElement;
};

export default StockStatusMessage;
